type PageScrollOptions = {
    initTop?: boolean, // trigger onTop on load
    offsetTop?: number,
    onTop?(): void,
    onBottom?(): void,
    onNavigate?(scrollY: number): void,
}
const usePageScroll = (options?: PageScrollOptions) => {
    let defaultOptions: PageScrollOptions = {
        initTop: false,
        offsetTop: 0,
        onTop() {
        },
        onBottom() {
        },
        onNavigate() {
        }
    }

    let opt: PageScrollOptions = {...{}, ...defaultOptions, ...(options || {})};

    let lastEventTriggered: string = '';
    return () => {
        if (opt.initTop && typeof opt.onTop === "function") {
            opt.onTop();
        }
        window.onscroll = () => {
            let event;
            //if (window.scrollY <= (opt.offsetTop || 0)) {
            if (window.scrollY === 0 ) {
                event = 'top';
            } else if (window.scrollY + window.innerHeight === document.documentElement.offsetHeight) {
                event = 'bottom';
            } else {
                event = 'navigate';
                //console.log("navigating", window.scrollY, window.outerHeight, window.innerHeight, document.documentElement.clientHeight, document.documentElement.offsetHeight,document.documentElement.scrollHeight);
            }

            if (event !== lastEventTriggered) {
                if (event === 'top' && typeof opt.onTop === "function") opt.onTop();
                if (event === 'bottom' && typeof opt.onBottom === "function") opt.onBottom();
                //&& (opt.offsetTop ? window.scrollY > (opt.offsetTop || 0) : true)
                if (event === 'navigate' && typeof opt.onNavigate === "function") opt.onNavigate(window.scrollY);
                lastEventTriggered = event;
            }

            //console.log(lastEventTriggered)

        }

        return (): void => {
            window.onscroll = null;
        };

    }

}

export default usePageScroll;
